module.exports = __webpack_public_path__ + "img/brand-3.f41a1874.svg";